import { api } from '@/lib/api';
import { mutationKeys } from '../mutationKeys';

export interface AddStockPayload {
  id: number;
  amount: number;
  expire_date: string;
  lot_number: string;
}

export interface UpdateStockPayload {
  id: number;
  expire_date: string;
  lot_number: string;
}

export const addStockMutation = () => ({
  mutationKey: mutationKeys.stock.add(),
  mutationFn: async (payload: AddStockPayload) => {
    const response = await api
      .post(`items-stock/${payload.id}/add`, {
        json: {
          amount: payload.amount,
          expire_date: payload.expire_date,
          lot_number: payload.lot_number,
        },
      })
      .json();
    return response;
  },
});

export const updateStockMutation = () => ({
  mutationKey: mutationKeys.stock.update(),
  mutationFn: async (payload: UpdateStockPayload) => {
    const response = await api
      .patch(`items-stock/${payload.id}`, {
        json: {
          expire_date: payload.expire_date,
          lot_number: payload.lot_number,
        },
      })
      .json();
    return response;
  },
});
